import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { PaymentResponseRedirect } from "@swo/storefront";
import React, { useEffect } from "react";
import { SwarovskiButton } from "../../../../components/_shared-components/ui-elements/SwarovskiButton";
import { Suspended } from "../../../../utils/react/suspended";
import { SmallStyledSpinner } from "../../../../components/_shared-components/ui-elements/StyledSpinner";
import { clientSideRedirect } from "../../../../utils/browser/client-side-redirect";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../../components/T";

export const PaymentRedirect: ReactTFC<{ data: PaymentResponseRedirect; text: TranslatedValue }> = props => {
  const obj = clientSideRedirect(props.data);

  useEffect(() => {
    obj.action();
  }, [JSON.stringify(props.data)]);

  function getComponent() {
    switch (obj.tag) {
      case "GET": {
        return (
          <SwarovskiButton variant={"green"} as={"a"} isInternal={false} size={"normal"} link={obj.value}>
            <T>{props.text}</T>
          </SwarovskiButton>
        );
      }
      case "POST": {
        return (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
          <SwarovskiButton variant={"green"} as={"button"} size={"normal"} onClick={() => obj.value()}>
            <T>{props.text}</T>
          </SwarovskiButton>
        );
      }
      default: {
        const _: never = obj;
        return _;
      }
    }
  }

  const component = getComponent();

  return (
    <Suspended Fallback={<SmallStyledSpinner />} suspensionKey={"_"} timeoutMs={250}>
      {component}
    </Suspended>
  );
};
